import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const { height, backgroundColor } = attributes;
  const blockProps = useBlockProps.save();

  return (
    <div {...blockProps} style={{ height: `${height}px` }}>
      <div className="swiper-container">
        <div className="swiper-wrapper">
            <InnerBlocks.Content />
        </div>
        <div className="swiper-pagination"></div>
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </div>
    </div>
  );
};

export default save;
